module.exports = __webpack_public_path__ + "img/Copy-of-ExB-1.400b5b02.jpg";